// tslint:disable:max-line-length

export class Subjects {
  static all: any[] = [
    {
      id: 'budget',
      name: 'Budgetprocessen',
      type: 'custom',
      title: 'Få full kontroll över budget-processen',
      subhead:
        'Din budget är ett viktigt verktyg för att utveckla ditt företag och peka ut riktningen framåt. Men många företagare tycker att budgeteringen både tar tid och är administrativt betungande.',
      inlineSubhead: 'Få ut mer av det arbete som läggs ner på budgeten',
      text:
        'En budget bör grunda sig på de mål och den affärsplan som bolaget har satt för verksamheten. Därmed är budgetarbetet för nästkommande räkenskapsår en del av affärsplanen som sträcker sig över flera år.\n\n Budgeten behövs som ett riktmärke för organisationen att följa upp och analysera mot. Varför blev det bättre eller sämre än tänkt? Har vi gjort det vi sagt i affärsplanen?',
      infotitle: 'Fem tips för en smidig och värdeskapande budgetering',
      listItems: [
        'Grundarbetet är viktigt. Gör en tidplan, utse ansvariga och vilka i bolaget som ska vara involverade',
        'Sätt mål i form av nyckeltal som följs upp löpande och säkerställ att budgeten baseras på en affärsplan/verksamhetsplan',
        'Ha en tydlig arbetsprocess och få alla känna en delaktighet i de mål som sätts upp',
        'Analysera avvikelser för att lära dig mer om verksamheten, din omvärld och marknaden.',
        'Använd ett automatiserat verktyg - det spar tid och resurser och minskar risken för felinmatningar',
      ],
    },
    {
      id: 'budget_en',
      name: 'Budgetprocessen',
      type: 'custom',
      title: 'Get full control over the budget process',
      subhead:
        'Your budget is an important tool for developing your business and pointing out the direction ahead. But many entrepreneurs find that budgeting both takes time and is administratively burdensome.',
      inlineSubhead: 'Get more out of the work put into the budget',
      text:
        'A budget should be based on the goals and the business plan that the company has set for the business. Thus, the budget work for the next fiscal year is part of the business plan that spans several years.\n\n The budget is needed as a benchmark for the organization to follow up and analyze against. Why did it turn out better or worse than expected? Have we done what we said in the business plan?',
      infotitle: 'Five tips for flexible and value-creating budgeting',
      listItems: [
        'The ground work is important. Make a timetable, appoint responsible people and who in the company should be involved',
        'Set goals in the form of key figures that are followed up on an ongoing basis and ensure that the budget is based on a business plan/operational plan',
        'Have a clear work process and make everyone feel a part in the goals that are set',
        'Analyze deviations to learn more about the business, your environment and the market.',
        'Use an automated tool - it saves time and resources and reduces the risk of incorrect entries',
      ],
    },
    {
      id: 'visselblas',
      name: 'Visselblåsarlag',
      type: 'custom',
      title: 'Har du koll på den nya visselblåsarlagen?',
      subhead:
        'Har din organisation fler än 50 arbetstagare? I så fall omfattas företaget av den nya visselblåsarlagen, med krav på en visselblåsarfunktion, som trädde i kraft december 2021.',
      inlineSubhead: 'Fördelar med att införa en visselblåsarfunktion',
      text:
        'Ökad trovärdighet - att företaget värnar om sina anställda, sunda affärsrelationer och att upprätthålla ett etiskt och hållbart företagande\n \nMinskad risk för negativ medial uppmärksamhet \n \nKostnadsbesparing - en visselblåsarfunktion ökar chansen att upptäcka och hantera en incident tidigt\n \nEffektiv och diskret hantering av misstänkta oegentligheter \n \nTrygghet för anställda',
      infotitle: 'Viktiga punkter i visselblåsarlagen:',
      listItems: [
        'Den 17:e december 2023 måste visselblåsarfunktionen vara införd för företag med minst 50 arbetstagare. För de med fler än 249 arbetstagare gäller den 17:e juli 2022.',
        'Begreppet ”arbetstagare” omfattar fler personer i företaget än t.ex. anställda eller årsarbetskrafter.',
        'Det ska vara möjligt att rapportera muntligt, skriftligt och vid ett fysiskt möte, om så begärs. Det räcker alltså inte bara med en systemlösning.',
        'Bekräftelse att visselblåsarens rapport har tagits emot ska ske inom 7 dagar.',
        'De personer eller enheter som utses som mottagare av visselblåsarrapporter ska vara oberoende och självständiga.',
        'Visselblåsaren ska få skälig återkoppling om de åtgärder som vidtagits inom tre månader.',
        'Arbetsgivaren ska skriftligen dokumentera sina interna rapporteringskanaler och förfaranden för rapportering och uppföljning.',
      ],
    },
    {
      id: 'internKontroll',
      name: 'Riskhantering',
      type: 'custom',
      title: 'Styr med riskhantering och intern kontroll',
      subhead:
        'För att nå ökad tillväxt, trygghet och en långsiktigt hållbar utveckling är det viktigt att din organisation har ett ramverk för styrning och intern kontroll. Utveckla och förbättra processer och kontroller som möjliggör effektiv styrning.',
      inlineSubhead: 'Arbete med riskhantering och intern kontroll',
      text:
        'Processen för intern styrning och kontroll är återkommande och påverkas av bolagets styrelse, ledning och annan personal. Den består av ett antal komponenter som samverkar och uppnås genom att risker kopplade till verksamhetsmålen hanteras.\n\nAlla verksamheter har risker som behöver mitigeras. Avsaknad av effektiv kontrollmiljö ökar chansen för att väsentliga risker inträffar.',
      infotitle: 'Viktiga punkter i ert risk & kontrollarbete:',
      listItems: [
        'Kartlägg era processer. Ha en god kännedom över verksamhetens styr, lednings och stödprocesser.',
        'Utveckla processer för riskhantering, genomförande av riskbedömningar och formell dokumentation av identifierade risker.',
        'Hantera väsentliga risker genom effektiva kontrollåtgärder. Utforma nyckelkontroller',
        'Skapa uppföljningsprocesser genom att testa kontroller löpande för att säkerställa effektivitet och design.',
        'Rapportera resultat av kontrollarbetet till styrelse/-ledning.',
        'Vi hjälper bolag med praktisk tillämpbar riskhantering, internkontroll, regelefterlevnad och processeffektivisering',
      ],
    },
    {
      id: 'itRisk',
      name: 'Motverka IT-risker',
      type: 'custom',
      title: 'Så kan ni motverka it-risker',
      subhead:
        'Digitaliseringen ökar och cyberattackerna blir allt mer sofistikerade. Att skydda företaget mot digitala intrång och cyberhot blir allt viktigare. Riskerna omfattar allt från mjukvaru- och systemfel till att brottslingar tar sig in i it-miljöer.',
      inlineSubhead: 'Vanliga anledningar att hacka företags it-system:',
      text:
        'Komma åt affärskritisk information \n\nLura till sig pengar\n\nUtöva utpressning genom att kapa systemet\n\nAtt allvarligt skada företagets renommé',
      infotitle: 'Tips för att bli cybersäker',
      listItems: [
        'Utveckla en styrmodell för informationssäkerhet och IT',
        'Granska er it-miljö för att hitta konkreta områden där skyddsåtgärder bör vidtas.',
        'Stresstesta it-miljön',
        'Utbilda alla anställda om cyberhot- och risker (till exempel nätfiske och falska webbsidor) ',
        'Använd starka och säkra lösenord',
        'Ta fram kontinuitets- och återställningsplaner',
      ],
    },
    {
      id: 'moms',
      name: 'Hantera moms rätt',
      type: 'custom',
      title: 'Hanterar ditt bolag momsen rätt?',
      subhead:
        'Moms är något som kan påverka ditt bolag på både lång kort sikt. Genom att skaffa dig kunskap om rätt och hållbar hantering kan du spara tid och undvika känslan av ovisshet kring momsen.',
      inlineSubhead: 'Momsregler och praxis är under ständig utveckling',
      text:
        'Momsreglerna är komplicerade och svårtolkade. Till detta kommer att det ofta är fråga om stora belopp, eller belopp som redovisas återkommande. Inom momsområdet sker en ständig utveckling genom bl.a. de många rättsfall som meddelas och ställningstaganden som publiceras av Skatteverket. Momsreglerna är speciella eftersom de är harmoniserade med EU-rätten genom mervärdesskattedirektivet. I stort sett varje vecka kommer nya EU-domar och avgöranden från våra svenska domstolar som påverkar hur momsen ska hanteras.',
      infotitle: 'Fem vanliga risker med momshantering',
      listItems: [
        'Bristfälliga rutiner vid EU- och exportförsäljning. Säljaren har bevisbördan för att svensk moms inte tas ut.',
        'Risk för momsregistrering utomlands vid exempelvis s.k. kedjetransaktioner (när vara säljs vidare mellan fler än två parter men det endast finns en gränsöverskridande transport).',
        'Risk för felaktig hantering av moms vid webförsäljning till privatpersoner i andra länder.',
        'Vid ny,- till,- ombyggnation, byte av hyresgäster och försäljning av fastighet.',
        'Risk för felaktiga avdrag för ingående moms vid s.k. blandad verksamhet (både momspliktig och momsfri verksamhet).',
      ],
    },
    {
      id: 'loneprocess',
      name: 'Löneprocessen',
      type: 'custom',
      title: 'Har du en fungerande och effektiv löneprocess?',
      subhead:
        'Löneprocessen är den mest omfattande av alla HR-processer i ett företag. Med en bra lönehantering kan man både stödja verksamheten och hjälpa till att styra företaget dit man vill.',
      inlineSubhead: 'Systemstöd och kompetens',
      text:
        'Att ha ett bra systemstöd är centralt. Det minskar risken för fel och ger en bättre kvalitet i arbetet. \n\nÄven om du har ett bra system måste du säkerställa att den som har hand om löneprocesserna har rätt kompetens, är påläst och uppdaterad på lagar och regler. En person som även kan bistå med rådgivning och hantera vanliga lönefrågor.',
      infotitle: 'Tips för att få full kontroll på lönehanteringen',
      listItems: [
        'Lägg tid på en detaljerad processbeskrivning.',
        'Identifiera vad i processen som kan automatiseras och digitaliseras. T ex in-utdata, myndighetsrapportering, kvittohantering.',
        'Investera tid på att göra en översyn av system som hanterar löner.',
        'Säkerställ att löneprocessen följer GDPR.',
        'Se din lön som en hållbarhetsfråga.',
      ],
    },
    {
      id: 'loneprocess_2406',
      name: 'Löneprocessen',
      type: 'custom',
      title: 'Har du en fungerande och effektiv löneprocess?',
      subhead:
        'Löneprocessen är den mest omfattande av alla HR-processer i ett företag. Med en bra lönehantering kan man både stödja verksamheten och hjälpa till att styra företaget dit man vill.',
      inlineSubhead: 'Systemstöd och kompetens',
      text:
        'Att ha ett bra systemstöd är centralt. Det minskar risken för fel och ger en bättre kvalitet i arbetet. \n\nÄven om du har ett bra system måste du säkerställa att den som har hand om löneprocesserna har rätt kompetens, är påläst och uppdaterad på lagar och regler. En person som även kan bistå med rådgivning och hantera vanliga lönefrågor.',
      infotitle: 'Tips för att få full kontroll på lönehanteringen',
      listItems: [
        'Lägg tid på en detaljerad processbeskrivning.',
        'Identifiera vad i processen som kan automatiseras och digitaliseras. T ex in-utdata, myndighetsrapportering, kvittohantering.',
        'Investera tid på att göra en översyn av system som hanterar löner.',
        'Gör en kompetensinventering på löneavdelningen.',
        'Säkerställ att löneprocessen följer GDPR.',
        'Se din lön som en hållbarhetsfråga.',
      ],
    },
    {
      id: '312-regler',
      name: '3:12-regler',
      type: 'custom',
      title: '3:12-regler för delägare i fåmansföretag',
      subhead:
        'Är du ägare i ett fåmansföretag? För att få tillgodoräkna sig ett löneutrymme måste delägaren eller en närstående ta ut en lön om: 6 IBB + 5% av lönesumman i bolaget men dock högst 9,6 IBB',
      inlineSubhead: 'Beloppsgränser',
      text:
        '6 IBB motsvarar: \n426 000 kronor (löneåret 2022) \n445 800 kronor (löneåret 2023) \n\n9,6 IBB motsvarar: \n681 600 kronor (löneåret 2022) \n713 280 kronor (löneåret 2023)\n\nSchablonbelopp: \n2022: 187 550 kr \n2023: 195 250 kr',
      infotitle: 'Tips för att få full kontroll på lönehanteringen',
      listItems: [
        'Lägg tid på en detaljerad processbeskrivning.',
        'Identifiera vad i processen som kan automatiseras och digitaliseras. T ex in-utdata, myndighetsrapportering, kvittohantering.',
        'Investera tid på att göra en översyn av system som hanterar löner.',
        'Säkerställ att löneprocessen följer GDPR.',
        'Se din lön som en hållbarhetsfråga.',
      ],
    },
    {
      id: '312-regler_2406',
      name: '3:12-regler',
      type: 'custom',
      title: '3:12-regler för delägare i fåmansföretag',
      subhead:
        'Är du ägare i ett fåmansföretag? För att få tillgodoräkna sig ett löneutrymme måste delägaren eller en närstående ta ut en lön om: 6 IBB + 5% av lönesumman i bolaget men dock högst 9,6 IBB',
      inlineSubhead: 'Beloppsgränser',
      text:
        '6 IBB motsvarar: \n445 800 kronor (löneåret 2023) \n457 200 kronor (löneåret 2024) \n\n9,6 IBB motsvarar: \n713 280 kronor (löneåret 2023) \n731 520 kronor (löneåret 2024)\n\nSchablonbelopp: \n2023: 195 250 kr \n2024: 204 325 kr',
      infotitle: 'Tänk på detta när det gäller löneuttag',
      listItems: [
        'En utredning är tillsatt för att se över 3:12-reglerna. Utredningens förslag till förändringar ska presenteras 31 maj 2024.',
        'Bygg gränsbelopp genom lönebaserat utrymme om möjlighet och ytterligare behov av gränsbelopp finns. Reglerna kommer sannolikt inte bli gynnsammare i framtiden vid framtida nya lagförslag.',
        'Överväg att maximera fritt eget kapital för att öka handlingsfriheten vid framtida nya lagförslag.',
      ],
    },
    {
      id: 'basbelopp_2503',
      name: 'Ändrade basbelopp',
      type: 'custom',
      title: 'Ändrade basbelopp m.m.',
      subhead:
        'Högre basbelopp och därmed bl.a. högre gränsbelopp till ägare av fåmansföretag',
      inlineSubhead: 'Exempel på höjningar',
      text:
        'Det förhöjda prisbasbeloppet har för 2025 höjts från 58 800 kr till 60 000 kr \n\nInkomstbasbeloppet för 2024 är 76 200 kr, IBB för 2025 är 80 600 kr \n\nGränsbelopp enligt schablonregeln Inkomstår 2025: 209 550 kr (baseras på 2024 års IBB).',
      infotitle: 'Några effekter',
      listItems: [
        'Grundavdraget och jobbskatteavdraget höjs vilket innebär sänkt skatt på arbetsinkomst och pension',
        'SGI och taket för föräldraförsäkring höjs',
        'Skiktgränsen för statlig inkomstskattuppgår till 625 800 kr för inkomståret 2025.',
      ],
    },
    {
      id: 'basbelopp_2604',
      name: 'Ändrade basbelopp',
      type: 'custom',
      title: 'Ändrade basbelopp m.m.',
      subhead:
        'Högre basbelopp och därmed bl.a. högre gränsbelopp till ägare av fåmansföretag',
      inlineSubhead: 'Exempel på höjningar',
      text:
        'Det förhöjda prisbasbeloppet har för 2026 höjts från 60 000 kr till 60 500 kr \n\nInkomstbasbeloppet för 2025 är 80 600 kr, IBB för 2026 är 83 400 kr',
      infotitle: 'Några effekter',
      listItems: [
        'Grundavdraget och jobbskatteavdraget höjs vilket innebär sänkt skatt på arbetsinkomst och pension',
        'SGI och taket för föräldraförsäkring höjs',
        'Skiktgränsen för statlig inkomstskattuppgår till 643 000 kr för inkomståret 2026.',
      ],
    },
    {
      id: '312-spaning',
      name: 'Trendspaning: 3:12',
      type: 'custom',
      title: '3:12-regler - trendspaning',
      subhead:
        'Den 3 juni 2024 presenterades 3:12 utredning vars syfte är att förenkla och förbättra reglerna men samtidigt undvika inkomstomvandling. I höstas kom remissyttrandena med till övervägande del positiva svar. Nu inväntas lagrådsremiss innan proposition troligen släpps i höst.',
      inlineSubhead:
        'Viktigt med rätt löner och struktur redan under 2025 för att få med sig rätt belopp in till 2026',
      infotitle: '3:12-utredningens förslag',
      listItems: [
        'Grundbeloppet (tidigare schablonbeloppet) höjs från 2,75 IBB till 4 IBB per år (fördelas per individ och ägd andel av respektive bolag). Delägare som äger andelar i flera bolag ska fördela grundbeloppet proportionerligt mellan bolagen.',
        'Kapitalandelskravet/4 procentspärren slopas.',
        'Förenklingsregeln och huvudregeln slås ihop',
        'Löneuttagskravet tas bort men ersätts med ett löneavdrag',
        'Karenstiden förkortas från 5 till 4 år för övergången till okvalificerade andelar',
        'Ett gemensamt takbelopp för utdelning och kapitalvinst, 90 IBB för tre beskattningsår',
        'Närståendekretsen minskar, syskon ej längre närstående',
        'Inga förändrade skattesatser',
      ],
    },
    {
      id: '260205_312-spaning',
      name: 'Trendspaning: 3:12',
      type: 'custom',
      title: '3:12-regler - trendspaning',
      subhead:
        'I samband med riksdagens beslut om budgeten så antogs nya regler för fåmansföretag som gäller från 1 januari 2026.',
      inlineSubhead: 'OBS!',
      text:
        'Viktigt med rätt löner och struktur redan under 2025 för att få med sig rätt belopp in till 2026\n\nViktigare än tidigare att bedöma och ha koll på delägarens samtliga kvalificerade aktier när deklarationen upprättas, då det påverkar fördelningen av grundbeloppet.',
      infotitle: 'De nya 3:12-reglerna',
      listItems: [
        'Förenklingsregeln och huvudregeln slås ihop till en regel',
        'Grundbeloppet höjs från 2,75IBB till 4 IBB per år (fördelas per individ och ägd andel av respektive bolag. Max 4 IBB per individ.',
        'Delägare som äger andelar i flera bolag ska fördela grundbeloppet proportioneligt mellan bolagen vilket medför att det det kan bli mer fördelaktigt att samla alla äganden under ett bolag. Inte längre möjligt att välja för vilka aktier man använder grundbelopppet.',
        'Kapitalandelskravet/4 procentspärren slopas.',
        'Löneuttagskravet tas bort men ersätts med ett löneavdrag om 8 IBB.',
        'Återgån till civilrättslig dotterbolagsdefionition för aktiebolag vid beräkning av löneunderlag.',
        'Karenstiden förkortas från 5 till 4 år för övergången till okvalificerade andelar.',
        'Inga förändrade skattesatser',
        'Ingen förändrad närståendedefinition - syskon ses fortsatt som närstående.',
      ],
    },
    {
      id: 'sni_2025',
      name: 'Nya SNI-koder 2025',
      type: 'custom',
      title: 'Nya SNI-koder 2025 - dags att uppdatera',
      subhead:
        'SCB lanserar i slutet av 2025 ”SNI 2025” som är uppdaterad utifrån den nya versionen av europeiska näringsgrensstandarden (NACE). Det är därför viktigt att ni går in och kontrollerar om er SNI-kod behöver ändras.',
      inlineSubhead: 'Senast 21 november 2025',
      text:
        'Fram till den 21 november finns det möjlighet att gå in via https://verksamt.se/sni2025 och uppdatera till ”SNI 2025”. Mer information hittar ni på SNI 2025. Om ni har frågor kan ni även vända er till någon i GT-teamet.',
      infotitle:
        'Att ni har rätt SNI-kod/koder registrerad för er verksamhet har betydelse för bland annat:',
      listItems: [
        'Era kostnader för försäkringar kan påverkas av SNI-koden.',
        'Er kreditvärdighet kan påverkas hos upplysningsföretag.',
        'Företagets synlighet kan påverkas då många upplysningssidor erbjuder möjlighet att filtrera företag inom en specifik bransch.',
        'Ni som företag kan få information som riktas till bransch utifrån SNI-koden.',
      ],
    },
    {
      id: 'sni_2025_en',
      name: 'New SNI-codes 2025',
      type: 'custom',
      title: 'New SNI Codes 2025 – Time to Update',
      subhead:
        'At the end of 2025, Statistics Sweden (SCB) will launch “SNI 2025,” which has been updated based on the new version of the European industry classification standard (NACE). It is therefore important that you check whether your SNI code needs to be updated.',
      inlineSubhead: 'Deadline: November 21, 2025',
      text:
        'Until November 21, you have the opportunity to update to “SNI 2025” via https://verksamt.se/sni2025. More information is available on the SNI 2025 page. If you have any questions, you can also contact someone in the GT team.',
      infotitle:
        'Having the correct SNI code(s) registered for your business is important because:',
      listItems: [
        'Your insurance costs may be affected by the SNI code.',
        'Your credit rating may be impacted by credit reporting agencies.',
        'Your company’s visibility may be influenced, as many business directories allow filtering by industry.',
        'Your company may receive industry-specific information based on the SNI code.',
      ],
    },
    {
      id: 'flex_start',
      name: 'Flex HRM',
      type: 'image',
    },
    {
      id: 'flex_time_redovisning',
      name: 'Valbar redovidningsperiod',
      type: 'image',
    },
    {
      id: 'flex_time_overtid',
      name: 'Övertidsbevakning',
      type: 'image',
    },
    {
      id: 'flex_time_franvaro',
      name: 'Ansöka om frånvaro',
      type: 'image',
    },
    {
      id: 'flex_time_stampla',
      name: 'Stämpling',
      type: 'image',
    },
    {
      id: 'flex_travel_kvitto',
      name: 'Automatisk kvittotolkning',
      type: 'image',
    },
    {
      id: 'flex_travel_bilresa',
      name: 'Spela in bilresa',
      type: 'image',
    },
    {
      id: 'flex_travel_kort',
      name: 'Företagskort',
      type: 'image',
    },
    {
      id: 'flex_plan_autobemanning',
      name: 'Autobemanning',
      type: 'image',
    },
    {
      id: 'flex_plan_kalkylera',
      name: 'Kalkylera personkostnader',
      type: 'image',
    },
    {
      id: 'flex_plan_pass',
      name: 'Passförfrågningar',
      type: 'image',
    },
    {
      id: 'sustainabilityImpact',
      name: 'Förutsättningar',
      type: 'chart',
    },
    {
      id: 'sustainabilityImpact2409',
      name: 'Förutsättningar Hållbarhet',
      type: 'chart',
    },
    {
      id: 'sustainabilityQuestions',
      name: 'Frågor Hållbarhet',
      type: 'chart',
    },
    {
      id: 'sustainabilityProcess',
      name: 'Process Hållbarhet',
      type: 'chart',
    },
    {
      id: 'gt_about_us',
      name: 'Om Grant Thornton',
      type: 'image',
    },
    {
      id: 'gt_our_customers',
      name: 'Våra kunder',
      type: 'image',
    },
    {
      id: 'klimat_oversikt',
      name: 'Klimatnyckeltal - Översikt',
      type: 'image',
    },
    {
      id: '250922_Klimatnyckeltal',
      name: 'Klimatnyckeltal - Översikt',
      type: 'image',
    },
    {
      id: 'klimat_enkel',
      name: 'Klimatnyckeltal - Enkel',
      type: 'image',
    },
    {
      id: 'klimat_utokad',
      name: 'Klimatnyckeltal - Utökad',
      type: 'image',
    },
    {
      id: '250930_Klimatnyckeltal_utokad',
      name: 'Klimatnyckeltal - Utökad',
      type: 'image',
    },
    {
      id: 'radgivare_agardirektiv',
      name: 'Ägardirektiv',
      type: 'image',
    },
    {
      id: 'radgivare_aktivtstyrelsearbete',
      name: 'Aktivt styrelsearbete',
      type: 'image',
    },
    {
      id: 'radgivare_budgetprocess',
      name: 'Budgetprocess',
      type: 'image',
    },
    {
      id: 'radgivare_cfocoach',
      name: 'CFO-coach',
      type: 'image',
    },
    {
      id: 'radgivare_hallbarhetsarbete',
      name: 'Hållbarhetsarbete',
      type: 'image',
    },
    {
      id: 'radgivare_vardesimulering',
      name: 'Värdesimulering',
      type: 'image',
    },
    {
      id: 'avr_agardirektiv',
      name: 'Ägardirektivet',
      type: 'image',
    },
    {
      id: 'avr_aktivt_styrelsearbete',
      name: 'Aktivt styrelsearbete',
      type: 'image',
    },
    {
      id: 'avr_avdragsratt',
      name: 'Avdrag blandad verksamhet',
      type: 'image',
    },
    {
      id: 'avr_csrd',
      name: 'CSRD - EU:s hållbarhetslag',
      type: 'image',
    },
    {
      id: 'avr_cybersakerhetslag',
      name: 'Förslag ny cybersäkerhetslag',
      type: 'image',
    },
    {
      id: 'avr_esg_modell',
      name: 'ESG - modell för hållbarhet',
      type: 'image',
    },
    {
      id: 'avr_fel_moms',
      name: 'Vanliga fel inom moms',
      type: 'image',
    },
    {
      id: 'avr_hallbarhetskrav',
      name: 'Framtidens hållbarhetskrav',
      type: 'image',
    },
    {
      id: 'avr_kompetensutveckling',
      name: 'Webbinarier & nyhetsbrev',
      type: 'image',
    },
    {
      id: 'avr_levkedja',
      name: 'Utvärdera leverantörskedjan',
      type: 'image',
    },
    {
      id: 'avr_minska_klimat',
      name: 'Minska klimatpåverkan',
      type: 'image',
    },
    {
      id: 'avr_steget_mot_borsen',
      name: 'Steget mot börsen',
      type: 'image',
    },
    {
      id: 'avr_visselblasarlag',
      name: 'Visselblåsarlag',
      type: 'image',
    },
    {
      id: 'reporting',
      name: 'Ny rådgivningstjänst',
      type: 'image',
    },
    {
      id: 'reporting_screenshot',
      name: 'Exempel',
      type: 'image',
    },
    {
      id: 'system_support',
      name: 'Systemstöd',
      type: 'image',
    },
    {
      id: 'service_tree',
      name: 'Skatt',
      type: 'serviceTree',
    },
    {
      id: '250922_Sociala_nyckeltal',
      name: 'Sociala nyckeltal',
      type: 'image',
    },
    {
      id: '250922_Var_metod',
      name: 'Vår metod',
      type: 'image',
    },
    {
      id: '250922_VSME',
      name: 'VSME',
      type: 'image',
    },
    {
      id: '250922_ESRS',
      name: 'ESRS',
      type: 'image',
    },
    {
      id: '250922_Vardekedja',
      name: 'Värdekedja',
      type: 'image',
    },
    {
      id: '250922_Hallbarhetspyramid',
      name: 'Hållbarhetspyramid',
      type: 'image',
    },
    {
      id: '251027_Uppdateringar_K2',
      name: 'Uppdateringar i K2',
      type: 'image',
    },
    {
      id: '251027_Ej_K2_Foretag',
      name: 'Företag - ej K2',
      type: 'image',
    },
    {
      id: '251027_Ej_K2_Mindre_Foretag',
      name: 'Mindre företag - ej K2',
      type: 'image',
    },
    {
      id: '251027_Uppdateringar_K3',
      name: 'Uppdateringar i K3',
      type: 'image',
    },
    {
      id: '251027_Byt_K2_K3',
      name: 'Byta från K2 till K3',
      type: 'image',
    },
  ];

  static getSubjects(category: string): any[] {
    let ids: string[] = [];
    switch (category) {
      case 'counseling':
        ids = [
          // 'budget',
          'internKontroll',
          'itRisk',
          'moms',
          'loneprocess_2406',
          // '312-regler_2406',
          // 'basbelopp_2503',
          'basbelopp_2604',
          // 'sni_2025',
          // '251027_Uppdateringar_K2',
          // '251027_Ej_K2_Foretag',
          // '251027_Ej_K2_Mindre_Foretag',
          // '251027_Uppdateringar_K3',
          '251027_Byt_K2_K3',
        ];
        break;
      case 'certified_advisory':
        ids = [
          'radgivare_aktivtstyrelsearbete',
          'radgivare_budgetprocess',
          'radgivare_cfocoach',
          'radgivare_hallbarhetsarbete',
          'radgivare_vardesimulering',
          'radgivare_agardirektiv',
        ];
        break;
      case 'sustainability':
        ids = [
          'sustainabilityImpact2409',
          'sustainabilityQuestions',
          'sustainabilityProcess',
          '250922_Klimatnyckeltal',
          'klimat_enkel',
          '250930_Klimatnyckeltal_utokad',
          '250922_Sociala_nyckeltal',
          '250922_Var_metod',
          '250922_VSME',
          '250922_ESRS',
          '250922_Vardekedja',
          '250922_Hallbarhetspyramid',
          'avr_esg_modell',
          'avr_hallbarhetskrav',
          'avr_csrd',
          'avr_minska_klimat',
          'avr_levkedja',
        ];
        break;
      case 'gt_internal':
        ids = ['gt_about_us', 'gt_our_customers'];
        break;
      case 'reporting':
        ids = ['reporting', 'reporting_screenshot'];
        break;
      case 'auditor_reporting':
        ids = [
          'avr_esg_modell',
          'sustainabilityQuestions',
          'sustainabilityImpact2409',
          'sustainabilityProcess',
          'avr_aktivt_styrelsearbete',
          'avr_cybersakerhetslag',
          'avr_hallbarhetskrav',
          'avr_csrd',
          'avr_minska_klimat',
          'avr_levkedja',
          'internKontroll',
          'itRisk',
          'avr_steget_mot_borsen',
          'moms',
          'avr_avdragsratt',
          'avr_fel_moms',
          // '312-regler_2406',
          // 'basbelopp_2503',
          'basbelopp_2604',
          // '312-spaning',
          '260205_312-spaning',
          'budget',
          'loneprocess_2406',
          'avr_agardirektiv',
          'avr_kompetensutveckling',
          'system_support',
          'service_tree',
        ];
        break;
      case 'flex_start':
        ids = ['flex_start'];
        break;
      case 'flex_time':
        ids = [
          'flex_time_redovisning',
          'flex_time_overtid',
          'flex_time_franvaro',
          'flex_time_stampla',
        ];
        break;
      case 'flex_travel':
        ids = ['flex_travel_kvitto', 'flex_travel_bilresa', 'flex_travel_kort'];
        break;
      case 'flex_plan':
        ids = [
          'flex_plan_autobemanning',
          'flex_plan_kalkylera',
          'flex_plan_pass',
        ];
        break;
    }
    return ids.map((id) => this.all.find((subject) => subject.id === id));
  }

  static getCategory(id: string): string {
    switch (id) {
      case 'flex_start':
        return 'Flex HRM';
      case 'flex_time':
        return 'Flex HRM Tid';
      case 'flex_travel':
        return 'Flex HRM Resa';
      case 'flex_plan':
        return 'Flex HRM Plan';
      case 'sustainability':
        return 'Hållbarhet';
      case 'gt_internal':
        return 'Företagspresentation';
      case 'reporting':
        return 'Rapportering';
      case 'certified_advisory':
        return 'Behörig rådgivare';
      case 'auditor_reporting':
        return 'Avrapporteringsmötet';
      default:
        return 'Rådgivning';
    }
  }

  static getSubjectsByIds(ids: string[]): any[] {
    if (!ids) {
      return [];
    }
    return ids.map((id) => this.all.find((subject) => subject.id === id));
  }

  static getSubjectById(id: string): any {
    return this.all.find((subject) => {
      return subject.id === id;
    });
  }
}
